var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vue-dropzone',{attrs:{"re":"imgDropZone","id":"bg-dropzone","include-styling":true,"options":_vm.dropzoneOptions},on:{"vdropzone-file-added":_vm.uploadStared}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }